import { render } from "./RoseChartD3.vue?vue&type=template&id=d37a8d4a"
import script from "./RoseChartD3.vue?vue&type=script&lang=js"
export * from "./RoseChartD3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__